// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GaPz16 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
  height: 100%;
  overflow: hidden;
  flex: 1;
  min-width: 0;
}

.WoE0p7 {
  position: relative;
  flex: 1;
  min-height: 0;
  padding: var(--spacing-3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.k4KAFh {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 1rem;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

.umG6SM {
  font-size: 14px;
  color: #475569;
  margin-bottom: 0;
  line-height: 1.6;
  max-width: 380px;
}

.WoE0p7.Lc7KRt {
  padding: 24px 24px 0;
}

.WoE0p7 .RE9EHR {
  width: 72px;
  height: 72px;
  margin-bottom: 24px;
  background-color: transparent;
}

.WoE0p7 .gnDR_u {
  width: 72px;
  height: 72px;
}

.k4KAFh.REuooP {
  max-width: none;
  margin: 0 0 8px;
  color: #1f1f1f;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.6;
  letter-spacing: normal;
}

.umG6SM.mu0TSw {
  width: 300px;
  max-width: 100%;
  margin: 0;
  color: #1f1f1f;
  font-size: 14px;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .GaPz16 {
    gap: 16px;
  }
  .WoE0p7 {
    padding: 2.5rem 2rem;
  }
  .k4KAFh {
    font-size: 1.5rem;
  }
  .umG6SM {
    font-size: 0.95rem;
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/HiringPage/components/HiringFeedback/HiringFeedbackLayout.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":[".stepContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n  height: 100%;\n  overflow: hidden;\n  flex: 1;\n  min-width: 0;\n}\n\n.activationFeedbackContent {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  padding: var(--spacing-3);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 1rem;\n  line-height: 1.3;\n  letter-spacing: -0.02em;\n}\n\n.description {\n  font-size: 14px;\n  color: #475569;\n  margin-bottom: 0;\n  line-height: 1.6;\n  max-width: 380px;\n}\n\n.activationFeedbackContent.emissorFeedbackContent {\n  padding: 24px 24px 0;\n}\n\n.activationFeedbackContent .emissorIconContainer {\n  width: 72px;\n  height: 72px;\n  margin-bottom: 24px;\n  background-color: transparent;\n}\n\n.activationFeedbackContent .emissorIcon {\n  width: 72px;\n  height: 72px;\n}\n\n.title.emissorTitle {\n  max-width: none;\n  margin: 0 0 8px;\n  color: #1f1f1f;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.6;\n  letter-spacing: normal;\n}\n\n.description.emissorDescription {\n  width: 300px;\n  max-width: 100%;\n  margin: 0;\n  color: #1f1f1f;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n@media (max-width: 768px) {\n  .stepContent {\n    gap: 16px;\n  }\n  .activationFeedbackContent {\n    padding: 2.5rem 2rem;\n  }\n  .title {\n    font-size: 1.5rem;\n  }\n  .description {\n    font-size: 0.95rem;\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepContent": `GaPz16`,
	"activationFeedbackContent": `WoE0p7`,
	"title": `k4KAFh`,
	"description": `umG6SM`,
	"emissorFeedbackContent": `Lc7KRt`,
	"emissorIconContainer": `RE9EHR`,
	"emissorIcon": `gnDR_u`,
	"emissorTitle": `REuooP`,
	"emissorDescription": `mu0TSw`
};
module.exports = ___CSS_LOADER_EXPORT___;
